import React from "react";
import { Formik, Form, Field } from "formik";
import styled from "styled-components";

const { REACT_APP_OPENAI_API_KEY } = process.env;
const API_URL = "https://api.openai.com/v1/chat/completions";

const SubmitButton = styled.input`
  margin: 1rem 0;
  padding: 0.2rem 0.75rem;
  line-height: 1.6;
  &[type="submit"] {
    padding: 0.5em 1em;
    border: 1px solid;
    border-radius: 2em;
    background: ${(props) => props.theme.colors.color1};
    color: white;

    &:hover {
      background: ${(props) => props.theme.colors.color2};
    }

    &[disabled] {
      opacity: 0.75;
      filter: grayscale(1);
    }
  }
`;

const SubmitHolder = styled.div`
  display: grid;
  grid-template-columns: 4fr 1fr;
  gap: 1rem;
`;

const ChatGPTForm = (props) => {
  const onSubmit = async (values, setSubmitting, resetForm) => {
    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${REACT_APP_OPENAI_API_KEY}`,
        },
        body: JSON.stringify({
          model: "gpt-4o",
          max_tokens: 1200,
          messages: [
            ...props.messages,
            { role: "user", content: values.prompt },
          ],
        }),
      });

      const data = await response.json();
      const rawResponse = data.choices[0].message.content;
      const preset = rawResponse ? JSON.parse(rawResponse) : null;

      console.log("preset", preset);

      if (typeof preset === "object" && preset !== null) {
        props.updatePreset(preset);

        setSubmitting(false);
        props.setMessages([
          ...props.messages,
          { role: "user", content: values.prompt },
          { role: "assistant", content: rawResponse },
        ]);

        setTimeout(() => {
          resetForm();
        }, 200);
      } else {
        alert("The ChatGPT response is not a valid data object. Try again");
      }
    } catch (error) {
      console.error("Error:", error);

      alert(
        "An error occured. Check the console to read more about the error."
      );
    }
  };

  return (
    <Formik
      initialValues={{ prompt: "" }}
      onSubmit={(values, { setSubmitting, resetForm }) =>
        onSubmit(values, setSubmitting, resetForm)
      }
    >
      {({ isSubmitting }) => (
        <Form method="post" name="chat-gpt-form">
          <div>
            <SubmitHolder>
              <fieldset>
                <label htmlFor="prompt">Ask AI to generate a pattern for you</label>
                <Field type="text" name="prompt" placeholder="Your AI prompt" />
              </fieldset>
              <SubmitButton
                name="submit"
                type="submit"
                disabled={isSubmitting}
                value={isSubmitting ? "Loading..." : "Send prompt"}
              />
            </SubmitHolder>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ChatGPTForm;
